// Extend window interface for CONFIGS
declare global {
  interface Window {
    CONFIGS?: {
      ENV?: string
    }
  }
}

function hasScriptAlreadyLoaded(externalSrc: string): boolean {
  const scripts = document.getElementsByTagName('script')
  let containsScript = false
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i] && scripts[i].src && scripts[i].src.includes(externalSrc)) {
      containsScript = true
    }
  }
  return containsScript
}

function logTracking(logHeader: string, logMessage: string): void {
  if (window.CONFIGS && window.CONFIGS.ENV && window.CONFIGS.ENV !== 'prod') {
    /* eslint-disable no-console */
    console.log(`${logHeader}:`, logMessage)
  }
}

export { hasScriptAlreadyLoaded, logTracking }
